import React from 'react'
import { Navigate } from 'react-router-dom'
import type { RouteObject } from 'react-router-dom'
import { AuthGuard } from '@/features/auth/components/AuthGuard'
import { AppLayout } from '@/features/layout/AppLayout'

const DashboardPage = React.lazy(() =>
  import('@/features/dashboard/pages/DashboardPage').then((m) => ({ default: m.DashboardPage }))
)
const GiftCodesPage = React.lazy(() =>
  import('@/features/giftcodes/pages/GiftCodesPage').then((m) => ({ default: m.GiftCodesPage }))
)
const ReferralsPage = React.lazy(() =>
  import('@/features/referrals/pages/ReferralsPage').then((m) => ({ default: m.ReferralsPage }))
)
const WalletPage = React.lazy(() =>
  import('@/features/wallet/pages/WalletPage').then((m) => ({ default: m.WalletPage }))
)

const SecureProfilePage = React.lazy(() =>
  import('@/features/profile/pages/SecureProfilePage').then((m) => ({ default: m.SecureProfilePage }))
)
const MonthlyBonusPage = React.lazy(() =>
  import('@/features/bonus/pages/MonthlyBonusPage').then((m) => ({ default: m.MonthlyBonusPage }))
)
const AuthCallbackPage = React.lazy(() =>
  import('@/features/auth/pages/AuthCallbackPage').then((m) => ({ default: m.AuthCallbackPage }))
)

const SuspenseWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <React.Suspense
    fallback={
      <div className="flex items-center justify-center min-h-[50vh]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#0068FF]" />
      </div>
    }
  >
    {children}
  </React.Suspense>
)

export const routeDefinitions: RouteObject[] = [
  {
    path: '/',
    element: (
      <AuthGuard>
        <AppLayout />
      </AuthGuard>
    ),
    children: [
      { index: true, element: <SuspenseWrapper><DashboardPage /></SuspenseWrapper> },
      { path: 'gift-codes', element: <SuspenseWrapper><GiftCodesPage /></SuspenseWrapper> },
      { path: 'referrals', element: <SuspenseWrapper><ReferralsPage /></SuspenseWrapper> },
      { path: 'monthly-bonus', element: <SuspenseWrapper><MonthlyBonusPage /></SuspenseWrapper> },
      { path: 'payouts', element: <SuspenseWrapper><WalletPage /></SuspenseWrapper> },
      { path: 'buy-credits', element: <Navigate to="/" replace /> },
      { path: 'tax-profile', element: <SuspenseWrapper><SecureProfilePage /></SuspenseWrapper> },
    ],
  },
  {
    path: '/auth/callback',
    element: <SuspenseWrapper><AuthCallbackPage /></SuspenseWrapper>,
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]
